import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

const integrationsKey = (entityId) => ['admin', 'entities', entityId, 'integrations'];

export function useEntityIntegrations(entityId) {
  return useQuery({
    queryKey: integrationsKey(entityId),
    queryFn: () => api.get(`/admin/entities/${entityId}/integrations`),
    staleTime: 30_000,
    enabled: Boolean(entityId),
  });
}

function useIntegrationMutation(entityId, mutateFn) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: mutateFn,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: integrationsKey(entityId) });
    },
  });
}

export function useCreateIntegration(entityId) {
  return useIntegrationMutation(entityId, (body) =>
    api.post(`/admin/entities/${entityId}/integrations`, body)
  );
}

export function useUpdateIntegration(entityId) {
  return useIntegrationMutation(entityId, ({ kind, ...body }) =>
    api.patch(`/admin/entities/${entityId}/integrations/${kind}`, body)
  );
}

export function useDeleteIntegration(entityId) {
  return useIntegrationMutation(entityId, (kind) =>
    api.delete(`/admin/entities/${entityId}/integrations/${kind}`)
  );
}
